import { FDBigPicklistInput } from '@facet-wealth/design';
import React from 'react';
import { inputDefaultProps, inputPropTypes } from 'Packages/FacetDesign/Components/propTypes';
import PropTypes from 'prop-types';
import { useDataAttrs } from 'Helpers/Testing';

const BigPicklistInput = (props) => {
  const {
    alignSelf,
    flex,
    flexGrow,
    flexShrink,
    fullWidth,
    error,
    helperTextValue,
    multiple,
    label,
    onBlur,
    onChange,
    onFocus,
    options,
    value,
    iconLocation,
    ...rest
  } = props;

  // If an option has the media property, use it as the icon for the FD component and also set the iconLocation
  const optionsWithMediaAsIcons = options.map(el => {
    return {
      ...el,
      icon: el.media || undefined,
      iconLocation,
    };
  });

  return (
    <FDBigPicklistInput
      alignSelf={alignSelf}
      error={error}
      flex={flex}
      flexGrow={flexGrow}
      flexShrink={flexShrink}
      fullWidth={fullWidth}
      multiple={multiple}
      helperText={helperTextValue}
      label={label}
      onBlur={onBlur}
      onChange={(val) => (val === undefined ? onChange('') : onChange(val))}
      onFocus={onFocus}
      options={optionsWithMediaAsIcons}
      value={value}
      {...useDataAttrs(rest)}
    />
  );
};

BigPicklistInput.defaultProps = {
  alignSelf: inputDefaultProps.alignSelf,
  error: inputDefaultProps.error,
  flex: inputDefaultProps.flex,
  flexGrow: inputDefaultProps.flexGrow,
  flexShrink: inputDefaultProps.flexShrink,
  helperTextValue: inputDefaultProps.helperTextValue,
  label: inputDefaultProps.label,
  onBlur: inputDefaultProps.onBlur,
  onFocus: inputDefaultProps.onFocus,
  iconLocation: inputDefaultProps.iconLocation,
  value: undefined,
};

BigPicklistInput.propTypes = {
  alignSelf: inputPropTypes.alignSelf,
  flex: inputPropTypes.flex,
  flexGrow: inputPropTypes.flexGrow,
  flexShrink: inputPropTypes.flexShrink,
  label: PropTypes.node,
  helperTextValue: inputPropTypes.helperTextValue,
  error: inputPropTypes.error,
  value: inputPropTypes.value,
  onBlur: inputPropTypes.onBlur,
  onChange: inputPropTypes.onChange.isRequired,
  onFocus: inputPropTypes.onFocus,
  options: inputPropTypes.options.isRequired,
  iconLocation: inputPropTypes.iconPosition,
};

export { BigPicklistInput };
